import { fromJS } from 'immutable';
import * as actions from 'react/api/actions/stopDetailsPopup';

const initialState = fromJS({});

const geocodeInitialState = fromJS({
  googleSuggestions: {},
  equipmentSuggestions: {}
});

export default (state = initialState, action) => {
  const routeId = (action.payload && action.payload.routeId) ? String(action.payload.routeId) : null;
  const stopId = (action.payload && action.payload.stopId) ? String(action.payload.stopId) : null;

  switch (action.type) {
    case actions.REQUEST_STOP_DETAILS_POPUP_DATA_STARTED: {
      return state.mergeIn([routeId, stopId], fromJS({
        ...action.payload,
        isLoadingData: true
      }));
    }
    case actions.REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_COMPLETED:
    case actions.REQUEST_STOP_DETAILS_POPUP_DATA_COMPLETED: {
      const { stop } = action.payload;
      return state.mergeIn([routeId, stopId], fromJS({
        isLoadingData: false,
        stop
      }));
    }
    case actions.STOP_DETAILS_POPUP_OPENED: {
      return state.setIn([routeId, stopId, 'isOpen'], true);
    }
    case actions.STOP_DETAILS_POPUP_CLOSED: {
      return state.setIn([routeId, stopId, 'isOpen'], false);
    }
    case actions.GEOCODE_ENABLED: {
      return state.mergeDeep(fromJS({
        geocode: {
          [routeId]: {
            [stopId]: {
              ...action.payload
            }
          }
        },
        actionButtons: {
          [routeId]: {
            [stopId]: {
              geocodeIsEnabled: true
            }
          }
        }
      }));
    }
    case actions.GEOCODE_DISABLED:
    case actions.GEOCODE_CANCELED:
    case actions.GEOCODE_SAVED: {
      return state.mergeDeep(fromJS({
        actionButtons: {
          [routeId]: {
            [stopId]: {
              geocodeIsEnabled: false
            }
          }
        },
        geocode: {
          [routeId]: {
            [stopId]: geocodeInitialState
          }
        }
      }));
    }
    case actions.GOOGLE_SUGGESTIONS_COMPLETED: {
      const { suggestions } = action.payload;
      return state.setIn(['geocode', routeId, stopId, 'googleSuggestions'], fromJS(suggestions));
    }
    case actions.EQUIPMENT_SUGGESTIONS_COMPLETED: {
      const { equipmentSuggestions } = action.payload;
      const suggestions = equipmentSuggestions.reduce((acc, curr) => {
        acc.push(curr.attributes);
        return acc;
      }, []);
      return state.setIn(['geocode', routeId, stopId, 'equipmentSuggestions'], fromJS(suggestions));
    }
    case actions.REQUEST_SIGNATURE_STARTED: {
      return state.setIn(['signature', routeId, stopId, 'isLoadingSignature'], true);
    }
    case actions.REQUEST_SIGNATURE_COMPLETED: {
      return state.mergeIn(['signature', routeId, stopId], fromJS({
        ...action.payload,
        isLoadingSignature: false,
        signatureIsAlreadyDownloaded: true
      }));
    }
    case actions.REQUEST_SIGNATURE_HEAT_MAP_STARTED: {
      return state.setIn([routeId, stopId, 'isRequestingSignatureHeatMap'], true);
    }
    case actions.REQUEST_SIGNATURE_HEAT_MAP_COMPLETED:
    case actions.REQUEST_SIGNATURE_HEAT_MAP_FAILED: {
      return state.setIn([routeId, stopId, 'isRequestingSignatureHeatMap'], false);
    }
    case actions.REQUEST_ARRIVAL_HEAT_MAP_STARTED: {
      return state.setIn([routeId, stopId, 'isRequestingArrivalHeatMap'], true);
    }
    case actions.REQUEST_ARRIVAL_HEAT_MAP_COMPLETED:
    case actions.REQUEST_ARRIVAL_HEAT_MAP_FAILED: {
      return state.setIn([routeId, stopId, 'isRequestingArrivalHeatMap'], false);
    }
    case actions.ZONES_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'zonesIsEnabled'], true);
    }
    case actions.ZONES_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'zonesIsEnabled'], false);
    }
    case actions.HEATMAPS_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'heatMapsIsEnabled'], true);
    }
    case actions.HEATMAPS_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'heatMapsIsEnabled'], false);
    }
    case actions.SIGNATURE_HEAT_MAP_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureHeatMapIsEnabled'], true);
    }
    case actions.SIGNATURE_HEAT_MAP_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureHeatMapIsEnabled'], false);
    }
    case actions.ARRIVAL_HEAT_MAP_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalHeatMapIsEnabled'], true);
    }
    case actions.ARRIVAL_HEAT_MAP_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalHeatMapIsEnabled'], false);
    }
    case actions.SIGNATURE_LOCATION_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureLocationIsEnabled'], true);
    }
    case actions.SIGNATURE_LOCATION_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureLocationIsEnabled'], false);
    }
    case actions.SIGNATURE_ACCURACY_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureAccuracyIsEnabled'], true);
    }
    case actions.SIGNATURE_ACCURACY_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'signatureAccuracyIsEnabled'], false);
    }
    case actions.ARRIVAL_LOCATION_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalLocationIsEnabled'], true);
    }
    case actions.ARRIVAL_LOCATION_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalLocationIsEnabled'], false);
    }
    case actions.ARRIVAL_ACCURACY_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalAccuracyIsEnabled'], true);
    }
    case actions.ARRIVAL_ACCURACY_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'arrivalAccuracyIsEnabled'], false);
    }
    case actions.DEPARTURE_LOCATION_ENABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'departureLocationIsEnabled'], true);
    }
    case actions.DEPARTURE_LOCATION_DISABLED: {
      return state.setIn(['actionButtons', routeId, stopId, 'departureLocationIsEnabled'], false);
    }
    default:
      return state;
  }
};
